import HTTP from "@/http-common";
export const state = {
  announcements: [],
  hasAnnouncement: false
};
export const getters = {
  announcements: state => {
    return state.announcements;
  },
  hasAnnouncement: state => {
    return state.hasAnnouncement;
  }
};
export const mutations = {
  SET_ANNOUNCEMENTS(state, data) {
    state.announcements = data;
  },
  HAS_ANNOUNCEMENT(state, data) {
    state.hasAnnouncement = data.some(x => x.isActive === true);
  }
};
export const actions = {
  async getAnnouncements({ commit, dispatch }) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let result = await HTTP.get(`OptusNBN/GetAnnouncementDetails`);
      if (result.data.data.length > 0) {
        commit("SET_ANNOUNCEMENTS", result.data.data);
        commit("HAS_ANNOUNCEMENT", result.data.data);
      }
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(result.data.data);
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async upsertAnnouncement({ dispatch }, payload) {
    dispatch("processLoader/setProcessActive", {}, { root: true });
    try {
      let result = await HTTP.post("OptusNBN/UpsertAnnouncement", payload);
      dispatch("getAnnouncements");
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(result.data.data);
    } catch (e) {
      let message = "";
      if (!e.response) message = e.message;
      else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  }
};
